import {
  DeviceResponse,
  EmptyResponse,
  SocialAccount,
  TypedApiRequestParams,
  UserDetail,
  UserDetailUpdate,
  UserProfile,
  UserProfileUpdate,
  UserSearchResult,
} from '../types';

const getUserDetail = (): TypedApiRequestParams<UserDetail> => ({
  url: 'user/me',
  method: 'GET',
  authRequired: true,
});

const updateUserDetail = (
  userDetailDict: UserDetailUpdate,
): TypedApiRequestParams<UserDetail> => ({
  url: 'user/me',
  method: 'PATCH',
  params: userDetailDict,
  authRequired: true,
});

const deleteUseraccount = (): TypedApiRequestParams<EmptyResponse> => ({
  url: 'user/account/delete',
  method: 'POST',
  authRequired: true,
});

const updateUserProfile = (
  userProfileDict: UserProfileUpdate,
): TypedApiRequestParams<UserProfile> => ({
  url: 'user/profile',
  method: 'PATCH',
  params: userProfileDict,
  authRequired: true,
});

const updateUserDevice = (
  deviceId: string,
  os: string,
  osVersion: string,
  name: string,
  appVersion: string,
  fbToken: string | null,
  deviceLocation: string | null,
): TypedApiRequestParams<DeviceResponse> => ({
  url: 'user/devices/',
  method: 'POST',
  params: {
    device_id: deviceId,
    os,
    os_version: osVersion,
    name,
    app_version: appVersion,
    fb_token: fbToken,
    last_position: deviceLocation,
  },
  authRequired: false,
});

const getSocialAccounts = (): TypedApiRequestParams<SocialAccount[]> => ({
  url: 'user/social-accounts',
  method: 'GET',
  authRequired: true,
});

const disconnectSocialAccount = (
  accountId: number,
): TypedApiRequestParams<EmptyResponse> => ({
  url: `user/social-accounts/${accountId}/disconnect/`,
  method: 'POST',
  authRequired: true,
});

const searchUsers = (
  query: string,
): TypedApiRequestParams<UserSearchResult[]> => ({
  url: 'user/search',
  method: 'GET',
  params: {q: query},
  authRequired: true,
});

export default {
  getUserDetail,
  updateUserDetail,
  deleteUseraccount,
  updateUserProfile,
  updateUserDevice,
  getSocialAccounts,
  disconnectSocialAccount,
  searchUsers,
};
